import React, { useState, useEffect } from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { IAward, TStandingType } from '../../../../../../store/admin/eventAwards/store';
import { IResult } from '../../../../../../store/admin/roundResults/store';
import { IHoleResult } from '../../../../../../store/admin/holeResults/store';

import { DollarInputAdornment } from '../../../../../../components/DollarInputAdornment/DollarInputAdornment';
import { EditableTableCell } from '../../../../Common/EditableTableCell/EditableTableCell';
import {
  useAssignResultsDispatch,
  useAssignResultsState
} from '../../AssignResults/Context/AssignResults.context';
import { blankAward } from '../../Utils/blankAward';
import { getResultField } from '../Utils/getResultField';
import { getResultPosition } from '../Utils/getResultPosition';
import { getUserAward } from '../Utils/getUserAward';
import { isResult } from '../Utils/isResult';
import { isHoleResult } from '../Utils/isHoleResult';
import { inchesToFeetAndInches } from '../../../../../../contrib/Utils/inchesToFeetAndInches';

interface IProps {
  result: IResult | IHoleResult;
  showNoPosition?: boolean;
  ctpResult?: boolean;
}

const ResultsTableRow = (props: IProps) => {
  const { result, showNoPosition, ctpResult } = props;

  const { awardsToUpdate, editMode, selectedCombination, userAwards } = useAssignResultsState();

  const { dispatch } = useAssignResultsDispatch();

  const [position, setPosition] = useState<number | string>('-');
  const [formatIsStableford, setFormatIsStableford] = useState(false);
  const [isAHoleLeaderboard, setIsAHoleLeaderboard] = useState(false);
  const [userAward, setUserAward] = useState<IAward>();

  const onAwardChange = (field: TStandingType) => (event: any) => {
    const hole = Number(Number(position) - 1);

    const value =
      userAward && userAward.id > 0
        ? {
            award: {
              ...userAward,
              [field]: event.target.value,
              hole: isAHoleLeaderboard && hole >= 0 ? hole : null
            },
            userId: result.userId
          }
        : {
            award: {
              ...blankAward,
              ...userAward,
              [field]: event.target.value,
              hole: isAHoleLeaderboard
                ? userAward && userAward.hole
                  ? userAward.hole
                  : hole >= 0
                  ? hole
                  : null
                : null,
              user: result.userId
            },
            userId: result.userId
          };

    dispatch({
      type: 'setAwardToUpdate',
      value
    });
  };

  useEffect(() => {
    if (selectedCombination) {
      setIsAHoleLeaderboard(selectedCombination.format.format.holeLeaderboard);
    }
  }, [selectedCombination]);

  useEffect(() => {
    if (selectedCombination) {
      setFormatIsStableford(selectedCombination.format.scoringFormat === 1);
    }
  }, [selectedCombination]);

  useEffect(() => {
    if (selectedCombination && isResult(result)) {
      setPosition(
        getResultPosition(
          result,
          selectedCombination.format.format.prefix,
          selectedCombination.scoreType,
          selectedCombination.format.considerFlights,
          showNoPosition,
          formatIsStableford
        )
      );
    }
  }, [selectedCombination, result, showNoPosition, formatIsStableford]);

  useEffect(() => {
    if (isHoleResult(result) && ctpResult && result.hole) {
      setPosition(result.hole + 1);
    }
  }, [result]);

  useEffect(() => {
    const newUserAward = getUserAward(
      result.userId,
      userAwards,
      awardsToUpdate,
      isAHoleLeaderboard,
      Number(Number(position) - 1)
    );

    setUserAward(newUserAward);
  }, [result, userAwards, awardsToUpdate, isAHoleLeaderboard, position]);

  const [resultScore, setResultScore] = useState<string | number | boolean | undefined>('');
  const [strokeResultScore, setStrokeResultScore] = useState<string | number | boolean | undefined>(
    ''
  );

  useEffect(() => {
    if (selectedCombination) {
      setStrokeResultScore(
        getResultField(
          result,
          'AuxScore',
          selectedCombination.format.format.prefix,
          selectedCombination.scoreType,
          formatIsStableford
        )
      );
    }
  }, [selectedCombination, result, formatIsStableford]);

  useEffect(() => {
    if (selectedCombination) {
      if (isResult(result)) {
        setResultScore(
          getResultField(
            result,
            'Score',
            selectedCombination.format.format.prefix,
            selectedCombination.scoreType,
            selectedCombination.format.considerFlights
          )
        );
      }

      if (ctpResult && isHoleResult(result)) {
        const processedDistance = inchesToFeetAndInches(result.pinDistance);

        if (processedDistance) {
          setResultScore(`${processedDistance.feet} ft. ${processedDistance.inches} in.`);
        }
      }
    }
  }, [selectedCombination, result, formatIsStableford]);

  return selectedCombination ? (
    <TableRow className="results-table-table-body-row">
      <TableCell>{position || ''}</TableCell>

      <TableCell>{`${result.userFirstName} ${result.userLastName}`}</TableCell>

      {selectedCombination.format.format.prefix === 'stroke' && (
        <TableCell>{strokeResultScore}</TableCell>
      )}

      <TableCell colSpan={selectedCombination.format.format.prefix !== 'stroke' ? 2 : 1}>
        {resultScore}
      </TableCell>

      <EditableTableCell
        label="label"
        type="number"
        value={userAward ? userAward.points : undefined}
        editMode={editMode}
        onChange={onAwardChange('points')}
        noIcon={true}
      />

      <EditableTableCell
        label="label"
        type="number"
        value={userAward ? userAward.scrip : undefined}
        editMode={editMode}
        onChange={onAwardChange('scrip')}
        inputAdornment={<DollarInputAdornment />}
        valuePrefix="$ "
        noIcon={true}
      />

      <EditableTableCell
        label="label"
        type="number"
        value={userAward ? userAward.cash : undefined}
        editMode={editMode}
        onChange={onAwardChange('cash')}
        inputAdornment={<DollarInputAdornment />}
        valuePrefix="$ "
        noIcon={true}
      />
    </TableRow>
  ) : (
    <></>
  );
};

export default ResultsTableRow;
